import { render, staticRenderFns } from "./UpdatePwd.vue?vue&type=template&id=23975238&scoped=true"
import script from "./UpdatePwd.vue?vue&type=script&lang=js"
export * from "./UpdatePwd.vue?vue&type=script&lang=js"
import style0 from "./UpdatePwd.vue?vue&type=style&index=0&id=23975238&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23975238",
  null
  
)

export default component.exports